/* eslint-disable */
import { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import { Chip, Tooltip } from '@mui/material';
import { Calculator, Filter } from 'lucide-react';
import { useAuth } from '@/Components/Auth/Login/auth';
import { urls } from '@/Constants';
import {
    convertWeightUnit, filtersInfoChip, formatDate, handleResponseStreamDownload, truncateText, useProductData, useQuery
} from '@/Helpers';
import { notificationServices } from '@/Services';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import wastageAction from '@/Actions/wastage.action';
import { grnQcLogService } from '@/Services/grnQcLog.services';
import { analyticsAction, formActions, modalActions } from '@/Actions';
import { POItemsModal } from '@/Components/Modals/POItemsModal';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import GlobalSearch from '@/Components/globalSearch/search';
import { Button } from '@/Components/ui/button';
import drawerActions from '@/Actions/drawer.actions';
import Tab from '@/Components/InfoTab/tab';
import GrnTable from '../GRNPage/GrnTable';
import authActions from '@/Actions/auth.actions';

const SPECIAL_COLUMNS = [
    {
        title: 'Return Id',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Store Name',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Vendor Name',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Initiated At',
        config: {
            type: 'DATA',
        }
    },
    {
        title: 'Closed At',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Po Id',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Status',
        config: {
            type: 'DATA',
        },
    },
];

const COLMAP = {
    'Return Id': 'id',
    'Vendor Name': 'vendorName',
    'Initiated At': 'createdAt',
    'Closed At': 'updatedAt',
    'Po Id': 'clientPoId',
    'Store Name': 'storeName',
    'Status': 'transactionStatus',
};

const aiMachineColMap = {
    Category: 'id',
    'Sub Category': 'id',
    'Sku Code': 'id',
    Store: 'storeName',
    'QC Time': 'QCTime',
    Result: 'result',
    'QR ID': 'OrderId',
    'Product Name': 'ProductName',
    'Net Quantity': 'id',
    Temp: 'Temp',
    'Vendor Name': 'vendorName',
};

const aiMachineSpecialColumns = [
    {
        title: 'Store',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'QC Time',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'QR ID',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Product Name',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Category',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Sub Category',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Sku Code',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Vendor Name',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Net Quantity',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Temp',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Result',
        config: {
            type: 'Data',
        },
    },
];

const tabList = [
    {
        value: 'vendorReturnLogs',
        label: 'Vendor Return Logs',
    },
    {
        value: 'aiMachineLogs',
        label: 'AI Supervisor GRN Scans',
    },
];

const exportInfo = {
    showExportBtn: true,
};
const dropDownItems = [
    {
        label: 'Return ID',
        value: 'id',
        placeholder: 'Search by Return ID',
        getData: true,
    },
    {
        label: 'Invoice Ref',
        value: 'invoiceRef',
        placeholder: 'Search by Invoice Ref',
        getData: true,
    },
    {
        label: 'PO ID',
        value: 'orderId',
        placeholder: 'Search by PO ID',
        getData: true,
    },
];

function VendorReturn({ navState }) {
    const history = useHistory();
    const location = useLocation();
    const { userConfig = {} } = useAuth();
    const { level } = userConfig?.userDetails || {};
    const navRequisites = navState?.[urls.PURCHASE_ORDERS]?.requisites ?? [];
    const navSelectedStore = navRequisites?.find((ele) => {
        return ele?.type === 'store';
    });
    const [search, setSearch] = useState({});
    const [activeTab, setActiveTab] = useState('vendorReturnLogs');
    const [filters, setFilters] = useState({});
    const queryParams = useQuery();
    const orderType = JSON.parse(queryParams?.get('orderType'));
    const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
    const grnList = useSelector((state) => state.wastage.grnList);
    const aiGrnList = useSelector(
        (state) => state.analytics.QUALITY_ANALYTICS.SEARCH_DATA.list
    );
    const dispatch = useDispatch();

    useEffect(() => {
        useProductData(dispatch);
    }, []);

    useEffect(() => {
        if (!orderType || orderType === 'capex') {
            setActiveTab('vendorReturnLogs');
        } else if (orderType === 'aiMachineLogs') {
            setActiveTab(orderType);
        } else {
            setActiveTab(orderType);
        }
    }, []);

    const getStatusColor = (status) => {
        switch ((status || '').toUpperCase()) {
            case 'PASSED':
                return 'bg-green-100 text-green-700';
            case 'FAILED':
                return 'bg-red-100 text-red-700';
            case 'PENDING':
                return 'bg-orange-100 text-orange-700';
            default:
                return '';
        }
    };

    const aiMachineSpecialColumnsMappings = {
        Store: (id, items) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{items}</div>
            );
        },
        'QC Time': (id, items) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{items}</div>
            );
        },
        'QR ID': (id, items) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{items}</div>
            );
        },
        'Product Name': (id, items) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{items}</div>
            );
        },
        Category: (id, items) => {
            const item = aiGrnList?.find((ele) => {
                return ele?.id === id;
            });
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {
                        products?.find(
                            (product) => Number(product?.id) === Number(item?.productId)
                        )?.categoryName
                    }
                </div>
            );
        },
        'Sub Category': (id, items) => {
            const item = aiGrnList?.find((ele) => {
                return ele?.id === id;
            });
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {
                        products?.find(
                            (product) => Number(product?.id) === Number(item?.productId)
                        )?.subCategoryName
                    }
                </div>
            );
        },
        'Sku Code': (id, items) => {
            const item = aiGrnList?.find((ele) => {
                return ele?.id === id;
            });
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {
                        products
                            ?.find(
                                (product) => Number(product?.id) ===
                                    Number(item?.productId)
                            )
                            ?.variants?.find(
                                (variant) => Number(variant?.id) ===
                                    Number(item?.variantId)
                            )?.clientVariantId
                    }
                </div>
            );
        },
        'Vendor Name': (id, items) => {
            return (
                <div
                    className='text-left text-[12px] text-nowrap'
                    title={items}
                >
                    {truncateText(items)}
                </div>
            );
        },
        'Net Quantity': (id, items) => {
            const obj = aiGrnList?.find((ele) => {
                return ele?.id === id;
            });
            const quantity = obj?.unit !== 'count' ? obj?.Weight : obj?.count;
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {convertWeightUnit(quantity, obj?.unit, undefined, true) ??
                        '-'}
                </div>
            );
        },
        Temp: (id, items) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{items}</div>
            );
        },
        Result: (id, items) => {
            return (
                <div
                    className={`w-[10rem] min-h-[2rem] text-[12px] flex flex-col items-center justify-center rounded-[4px] font-semibold ${getStatusColor(
                        items
                    )}`}
                >
                    {items}
                </div>
            );
        },
    };

    const handleGrnListFetch = async (filters) => {
        try {
            const notificationId = notificationServices.generateNotification({
                type: 'loading',
                message: 'loading...',
            });
            const searchFilters = {
                ...(search?.value === 'id' ? { id: search?.searchValue } : search?.value === 'invoiceRef' ? { invoiceRef: search?.searchValue } : search?.value === 'orderId' ? { orderId: search?.searchValue } : {}),
            };
            const responseData =
                await inventoryAnalyticsServices.fetchInvTransRecord({
                    req: {
                        data: {
                            filters: {
                                fromStoreId:
                                    Number(navSelectedStore?.value?.id) === -999
                                        ? null
                                        : navSelectedStore?.value?.id,
                                vendors: filters?.vendors?.id,
                                storeId: filters?.store?.id,
                                dateRangeFilter: {
                                    from: formatDate(
                                        filters?.dateRange?.from ?? new Date()
                                    ),
                                    to: formatDate(
                                        filters?.dateRange?.to ?? new Date()
                                    ),
                                    timeType: 'createdAt',
                                },
                                productId: filters?.product?.id ?? null,
                                productCategoryId:
                                    filters?.productCategory?.id ?? null,
                                transactionStatus: filters?.type,

                            },
                            ...(search?.searchValue ? { search: searchFilters } : {}),
                            type: 'VENDOR_RETURN',
                        },
                    },
                });
            if (responseData?.statusCode === 200) {
                dispatch(wastageAction.grnList(responseData?.data));
                notificationServices.generateNotification({
                    type: 'success',
                    message: 'Data fetch SuccessFully',
                    config: {
                        id: notificationId,
                    },
                });
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };

    const handleAiMachineFetch = async (filters) => {
        const req = {
            data: {
                storeId: filters?.store?.id,
                vendors: filters?.vendors?.id,
                dateRangeFilter: {
                    from: formatDate(filters?.dateRange?.from ?? formatDate(new Date())),
                    to: formatDate(filters?.dateRange?.to ?? formatDate(new Date())),
                },
                productId: filters?.product?.id ?? null,
                productCategoryId: filters?.productCategory?.id ?? null,
                status: filters?.type,
                qcType: 'VENDOR_RETURN',
                onlyMachineScans: true,
            },
        };
        try {
            const notificationId = notificationServices.generateNotification({
                type: 'loading',
                message: 'loading...',
            });
            const res = await grnQcLogService.fetchAiSupervisorScans(req);
            if (res?.statusCode === 200) {
                dispatch(analyticsAction.setAiQualityListScan(res?.data));
                notificationServices.generateNotification({
                    type: 'success',
                    message: 'Data fetch SucessFully',
                    config: {
                        id: notificationId,
                    },
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleListFetch = (filters) => {
        setFilters(filters);
        setActiveTab(filters?.orderType || 'vendorReturnLogs');
        if (filters?.orderType === 'vendorReturnLogs') {
            handleGrnListFetch(filters);
        } else if (filters?.orderType === 'aiMachineLogs') {
            handleAiMachineFetch(filters);
        }
    };


    const SPECIAL_ITEMS = {
        'Return Id': (id, item) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{item}</div>
            );
        },
        'Vendor Name': (id, item) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{item}</div>
            );
        },
        'Closed At': (id, item) => {
            if (!item) return '-';
            try {
                const date = new Date(item);
                if (isNaN(date.getTime())) return '-'; // Check if date is valid
                return (
                    <div className='text-left text-[12px] text-nowrap'>
                        {moment(date).format('YYYY-MM-DD HH:mm:ss')}
                        {/* {formatDateOneLiner(date)} */}
                    </div>
                );
            } catch (error) {
                return '-';
            }
        },
        'Store Name': (id, item) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{item}</div>
            );
        },
        'Initiated At': (id, item) => {
            if (!item) return '-';
            try {
                const date = new Date(item);
                if (isNaN(date.getTime())) return '-';
                return (
                    <div className='text-left text-[12px] text-nowrap'>
                        {moment(date).format('YYYY-MM-DD HH:mm:ss')}
                        {/* {formatDateOneLiner(date)} */}
                    </div>
                );
            } catch (error) {
                return '-';
            }
        },
        'Po Id': (id, item) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>{item}</div>
            );
        },
        'Status': (id, status) => {
            return (
                <div className='flex w-full justify-start items-center'>
                    {['PENDING'].includes(status) ? (
                        <div className='text-[#EA580C] bg-[#FFF7ED] py-2 px-2 rounded-md w-[100px] text-[12px]'>In Progress</div>
                    ) : ['COMPLETED'].includes(status) ? (
                        <div className='text-[#15803D] bg-[#DCFCE7] py-2 px-2 text-nowrap rounded-md w-fit text-[12px]'>Return Completed</div>
                    ) : '-'}
                </div>
            );
        },
    };

    const handleTabChange = (value) => {
        setActiveTab(value);
        if (value === 'aiMachineLogs') {
            handleAiMachineFetch(filters);
        } else {
            handleGrnListFetch(filters);
        }
    };

    const handleExport = async (filters) => {
        const notificationId = notificationServices.generateNotification({
            type: 'loading',
            message: 'loading...',
        });
        try {
            const response = await inventoryAnalyticsServices.exportGrnRecord({
                req: {
                    data: {
                        filters: {
                            fromStoreId:
                                Number(navSelectedStore?.value?.id) === -999
                                    ? null
                                    : navSelectedStore?.value?.id,
                            vendors: filters?.vendors?.id,
                            storeId: filters?.store?.id,
                            dateRangeFilter: {
                                timeType: 'createdAt',
                                from: formatDate(
                                    filters?.dateRange?.from ?? new Date()
                                ),
                                to: formatDate(
                                    filters?.dateRange?.to ?? new Date()
                                ),
                            },
                            productId: filters?.product?.id ?? null,
                            productCategoryId:
                                filters?.productCategory?.id ?? null,
                            transactionStatus: filters?.type,
                        },
                        type: 'VENDOR_RETURN',
                        export: true,
                    },
                },
            });
            if (response?.status === 200) {
                const exportFileName = `GRN Logs${moment(filters?.dateRange?.from).format('DD-MM-YYYY')}_${moment(filters?.dateRange?.to).format('DD-MM-YYYY')}.csv`;
                handleResponseStreamDownload(response, exportFileName);
                notificationServices.generateNotification({
                    type: 'success',
                    message: 'Data exported successfully',
                    config: {
                        id: notificationId,
                    },
                });
            } else {
                notificationServices.generateNotification({
                    type: 'error',
                    message: error,
                    config: {
                        id: notificationId,
                    },
                });
            }
        } catch (error) {
            notificationServices.generateNotification({
                type: 'error',
                message: error,
                config: {
                    id: notificationId,
                },
            });
        }
    };

    const filtersInfo = {
        header: {
            date: false,
            store: false,
            statusAndTypes: activeTab !== 'vendorReturnLogs',
            product: false,
        },
        dateRangeOnly: {
            text: 'Date Range (Initiated at) ',
            show: true,
        },
        product: {
            show: true,
            singleSelect: true,
        },
        vendor: {
            show: true,
        },
        productCategory: {
            show: true,
            singleSelect: true,
        },
        store: {
            show: true,
        },
        type: {
            text: 'Select Order Status',
            show: true,
            list: [
                {
                    type: 'COMPLETED',
                    label: 'Return Completed',
                },
                {
                    type: 'PENDING',
                    label: 'In Progress',
                },
            ],
        },
    };

    useEffect(() => {
        if (search?.keyPress && search?.searchValue?.trim() === '') {
            handleGrnListFetch(filters);
        }
    }, [search?.searchValue]);

    const handleCall = (e) => {
        if (e.key === 'Enter') {
            handleGrnListFetch(filters);
        }
    }

    return (
        <div>
            <POItemsModal />
            <ImagesFinder
                onSubmit={handleListFetch}
                filtersInfo={filtersInfo}
                exportInfo={exportInfo}
                tabType={activeTab}
                initialState={{
                    orderType: orderType ?? 'vendorReturnLogs',
                }}
            />
            <p className='text-[16px] font-bold text-start ml-[1rem] mt-[12px]'>
                Vendor Return Logs
            </p>
            <div className='flex flex-col p-2'>
                <div className='flex items-center justify-between w-full'>
                    <GlobalSearch
                        dropDownOptions={dropDownItems}
                        setSelectedValue={setSearch}
                        handleValue={handleCall}
                        placeholderText='Search ...'
                    />
                    <Button
                        onClick={(e) => {
                            dispatch(
                                drawerActions?.toggleFiltersDrawer(true, {
                                    handleDataExport: (filters) => {
                                        handleExport(filters);
                                    },
                                })
                            );
                        }}
                        className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
                    >
                        <span className='text-nowrap'>Filter & Export</span>
                        <Filter className='size-4' />
                    </Button>
                </div>
            </div>
            <div className='flex items-center justify-between w-full'>
                <Tab
                    tabValue={activeTab}
                    handleTabChange={handleTabChange}
                    tabList={tabList}
                />
                {filtersInfoChip(filtersInfo, filters)}
            </div>
            <div
                className='overflow-auto'
                style={{
                    maxHeight: '65vh',
                }}
            >
                {activeTab === 'vendorReturnLogs' && (
                    <GrnTable
                        data={grnList}
                        colMap={COLMAP}
                        special={SPECIAL_COLUMNS}
                        specialMappings={SPECIAL_ITEMS}
                        tableType='vendorReturnLogs'
                        location={location}
                    />
                )}
                {activeTab === 'aiMachineLogs' && (
                    <GrnTable
                        data={aiGrnList}
                        colMap={aiMachineColMap}
                        special={aiMachineSpecialColumns}
                        specialMappings={aiMachineSpecialColumnsMappings}
                        tableType='aiMachineLogs'
                        location={location}
                    />
                )}
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
    const { userPermissions, navState } = state.navigation;
    const { userList } = state?.auth;
    const stores = state?.form?.STORES?.data?.LIST;
    const { LIST: vendorsList } = state.form.ALL_VENDORS.data;
    const { query: searchQuery, searchBy } =
        state.analytics.AI_PRODUCTION_ANALYSIS.SEARCH_DATA;
    return {
        userPermissions,
        navState,
        userList,
        stores,
        vendorsList,
        searchQuery,
        searchBy,
    };
};

const mapDispatchToProps = {
    toggleModal: modalActions.toggleListModal,
    togglePOItemsModal: modalActions.togglePOItemsModal,
    togglePaymentModal: modalActions.togglePaymentModal,
    fetchUserList: authActions?.fetchUserList,
    fetchStoresList: formActions.gateway,
    fetchAllVendors: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorReturn);
